import React from 'react';

export default function DesktopOnlyBlock() {
    return (
        <div className="shop-create-desktopBlock">
            <div className="shop-create-desktopCard">
                <div className="shop-create-title">Только для мобильных</div>
                <div className="shop-create-subtitle">
                    Откройте эту страницу на экране телефона, чтобы создать бизнес.
                </div>
            </div>
        </div>
    );
}

